/**
 * Ensure first time athlete redirection.
 */
function ensureFirstTimeAthlete({ req, res, locals }, next) {
  const { activeUser } = locals;

  if (!activeUser) return next();

  const justLoggedIn = req.cookies.justLoggedIn;

  // if this is an athlete and the welcome video has not been shown, then redirect to calendar (CH3469)
  if (activeUser.coach && justLoggedIn && justLoggedIn !== "null") {
    const redirectPage = `/dashboard/calendar`;
    if (redirectPage !== req.pathname) return res.redirect(redirectPage);
  }

  return next();
}

export default ensureFirstTimeAthlete;
